<script setup>
  import { useI18n } from 'vue-i18n';
  import Icon from '@/components/icons/Icon.vue';

  const { t } = useI18n();
</script>

<template>
  <div class="jwx-pro-forecast__message-block jwx-pro-forecast__out-of-season-block">
    <div class="jwx-pro-forecast__out-of-season-icon">
      <Icon name="pro-forecast" />
    </div>      
    <p class="jwx-pro-forecast__message-title" data-size="large">This forecast is currently<br>out of season.</p>
    <p class="jwx-pro-forecast__message-body" data-size="large">{{ t('containers.proForecast.restartsSpring') }}</p>
  </div>
</template>